/* eslint-disable react/prop-types */
import React, {
  Fragment, useState, useEffect, useMemo,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Constants, { toISTDate } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import {
  DatePicker, Drawer, Upload, Radio, Select, Popconfirm,
} from 'antd';
import H3Image from '@Uilib/h3Image';
import CustomerActions from '@Actions/customerActions';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import DocConfigActions from '@Actions/docConfigActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import SOActions from '@Actions/sales/soActions';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import SelectDepartment from '@Components/Common/SelectDepartment';
import ProductActions from '@Actions/productActions';
import Helpers from '@Apis/helpers';
import BarcodeReader from '@Components/Common/BarcodeReader';
import Crown from '@Images/crown2.png';
import CustomFieldV3 from '@Components/Common/CustomFieldV3';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import CustomDocumentInputs from '@Components/Common/CustomDocumentInputs';
import FormLoadingSkull from '@Components/Common/formLoadingSkull';
import CustomDocumentColumns from '@Components/Common/CustomDocumentColumns';
import RichTextEditor from '@Components/Common/RichTextEditor';
import CustomerForm from '../../Customer/CustomerHome/CreateCustomer/CustomerForm';
import SelectCustomer from '../../../Common/SelectCustomer';
import PsLines from './PsLines';
import {
  INITIAL_STATE, handleDeleteHelper, handleProductChangeValueHelper, handleProductChangeHelper, toggleBatchInnerHelper, toggleBatchHelper, addNewRowHelper, customLineInputChangeHelper, getBatches, createPackingSlipHelper, customInputChangeHelper, handleQuantityChangeHelper, updateBatchValueHelper, handleMultiProductChangeHelper, getDataSource,
} from './packingSlipHelpers';
import ErrorHandle from '../../../Common/ErrorHandle';
import packingSlipErrors from './packingSlipErrors';
import PRZButton from '../../../Common/UI/PRZButton';
import PRZConfirmationPopover from '../../../Common/UI/PRZConfirmationPopover';
import PRZInput from '../../../Common/UI/PRZInput';
import PRZText from '../../../Common/UI/PRZText';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';
import DocumentNumberSeqInput from '../../../Admin/Common/DocumentNumberSeqInput';

const { Option } = Select;
const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

const PackingSlipForm = (props) => {
  const {
    createSOLoading, getSOByIdLoading, updateSOLoading, getProductsSuccess, getSOByIdSuccess, getCustomers, user, selectedSO, match, getDocConfigSOLoading, getProductByIdLoading, getSOById, getDocCFV2, getOrgStatus, getSO, MONEY, location, getOrgStatusSalesOrderLoading, cfV2DocPackingSlip, selectedSOForPs, isCarryForward, getDocConfig,
  } = props;

  const [state, setState] = useState(INITIAL_STATE(user));

  const {
    data, psTypeValue, packingSlipDate, attachments, description, showAddCustomer,
    showNewCustomerModal, allStock, visibleColumns, isUserReadyForCF, isUserReady,
    cfPackingSlipDoc, cfPackingSlipLine, tenantDepartmentId, departmentId, psNumber, selectedCustomerInfo, initialPsNumber, docSeqId,
    selectedCustomer, formSubmitted, soData, selectedSoValue, selectedCustomerSo, withApproval, currentAction, vehicleNumber, accountManager, isFromSalesOrder, documentUINames, updateDocumentReason, termsAndConditions,
  } = state;

  const updateState = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  useEffect(() => {
    let selectedTenantIdPs;
    if (selectedSOForPs) {
      selectedTenantIdPs = selectedSOForPs?.tenant_id;
    } else if (selectedSO) {
      selectedTenantIdPs = selectedSO.tenantId;
    } else {
      selectedTenantIdPs = user?.tenant_info?.tenant_id;
    }
    setState(INITIAL_STATE(user));

    const entityName = 'PACKING_SLIP';
    const permissionEntity = Helpers.permissionEntities.PACKING_SLIP;

    const { orderId } = match?.params;

    if (!selectedSOForPs) {
      getSOByIdSuccess(null);
    }

    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName,
    };

    getDocCFV2(payload);
    getOrgStatus({ orgId: user?.tenant_info?.org_id, entityName: 'SALES_ORDER', orderType: entityName }, () => { });

    sessionStorage.setItem('staticReservations', JSON.stringify({}));

    if (orderId && !selectedSOForPs) {
      getSOById({
        orgId: user?.tenant_info?.org_id,
        tenantId: Helpers.getTenantEntityPermission(
          user?.user_tenants,
          permissionEntity,
          Helpers.permissionTypes.UPDATE,
        ).join(',') || user?.tenant_info?.tenant_id,
        soId: orderId,
        orderType: entityName,
      });
    } 

    return () => {
      updateState('isUserReadyForCF', false);
    };
  }, []);

  useEffect(() => {
    getDocConfig(user?.tenant_info?.tenant_id, 'PACKING_SLIP', (doc) => {
      const termsData = doc?.find((item) => (item?.document_type === 'PACKING_SLIP_DOWNLOAD'))?.allowed_fields?.find((field) => (field?.field_name === 'default_t_and_c'))?.field_value;
      if (selectedSOForPs) { // creating PS from view SO
        updateState('termsAndConditions', termsData);
      } else if (selectedSO) { // updating a PS
        updateState('termsAndConditions', selectedSO?.terms_and_conditions || termsData);
      } else { // creating a fresh PS
        updateState('termsAndConditions', termsData);
      }
    });
  }, [selectedSO, selectedSOForPs]);

  useEffect(() => {
    if (selectedSOForPs && cfV2DocPackingSlip && !state?.selectedSOForPs) {
      const linesData = selectedSOForPs?.sales_order_lines;
      const accountManager = selectedSOForPs?.account_manager_info;
      const oldCustomField = selectedSOForPs?.custom_fields || [];
      const oldLineCustomField = linesData?.[0]?.so_line_custom_fields || [];
      const mergedArrayForDocCFs = CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip.data.document_custom_fields, oldCustomField);
      const mergedArrayForLineCFs = CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip.data.document_line_custom_fields, oldLineCustomField);
      const copyData = linesData?.map((order_line) => {
        const parentKey = uuidv4();
        const batches = getBatches(Helpers.batchSelectionMethod(order_line?.default_outwards_method || Helpers.getBatchMethod(order_line), order_line?.available_batches, order_line?.quantity), Math.min(order_line?.quantity + Number(order_line?.free_quantity), Helpers.getValueTotalInObject(order_line?.available_batches, 'available_qty')), order_line?.uom_info?.[0], order_line?.product_sku_info?.uom_info, null, parentKey, false, true);
        const mergedLineCustomFields = CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip.data.document_line_custom_fields, order_line?.custom_fields);
        const copyDataItem = {
          key: parentKey,
          tenant_product_id: order_line?.tenant_product_id,
          packing_slip_line_id: order_line?.order_line_id,
          product_type: order_line?.product_type,
          product_sku_id: order_line?.product_sku_info?.product_sku_id,
          available_qty: order_line?.available_qty,
          product_sku_info: order_line?.product_sku_info,
          product_sku_name: order_line?.product_sku_info?.product_sku_name,
          product_category_info: order_line?.product_sku_info?.product_category_info,
          quantity: order_line?.quantity,
          free_quantity: order_line?.free_quantity,
          showFreebie: Number(order_line?.free_quantity) > 0,
          packed_quantity: Number(order_line?.quantity || 0),
          packed_free_quantity: Number(order_line?.free_quantity || 0),
          bundle_products: order_line?.bundle_products?.map((item) => {
            const lineKey = uuidv4();
            return {
              ...item,
              parentKey,
              key: lineKey,
              uom_info: item?.uom_info?.[0],
              product_sku_name: item?.product_sku_info?.product_sku_name,
              quantity: item?.quantity,
              expiry_days: item?.product_sku_info?.expiry_days,
              product_sku_info: item?.product_sku_info,
              product_sku_id: item?.product_sku_info?.product_sku_id,
              batchConsumptionMethod: item?.default_outwards_method || Helpers.getBatchMethod(item),
              product_batches: getBatches(item?.available_batches, Math.min(item?.quantity, Helpers.getValueTotalInObject(item?.available_batches, 'available_qty')), item?.uom_info?.[0], item?.product_sku_info?.uom_info, null, lineKey),
            };
          }),
          uom_info: order_line?.uom_info[0],
          batchConsumptionMethod: order_line?.default_outwards_method || Helpers.getBatchMethod(order_line),
          product_batches: batches,
          lineCustomFields: mergedLineCustomFields,
          manufacturingDateFormat: order_line?.product_sku_info?.manufacturing_date_format,
          expiryDateFormat: order_line?.product_sku_info?.expiry_date_format,
        };

        return copyDataItem;
      });
      const filteredCfData = () => oldCustomField?.filter((customField) => cfV2DocPackingSlip?.data?.document_custom_fields?.some((x) => x?.cf_id === customField?.cf_id)) || [];
      setState((prevState) => ({
        ...prevState,
        packingSlipId: selectedSOForPs.order_id,
        psTypeValue: documentUINames.salesOrderUIName, // sales order
        isFromSalesOrder: true,
        data: copyData,
        selectedCustomer: selectedSOForPs.customer_id,
        selectedCustomerInfo: selectedSOForPs.customer_info,
        accountManager,
        selectedSoValue: copyData,
        selectedCustomerSo: selectedSOForPs,
        cfPackingSlipDoc: mergedArrayForDocCFs || [],
        cfPackingSlipLine: mergedArrayForLineCFs || [],
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(CustomFieldHelpers.postCfStructure(mergedArrayForLineCFs), visibleColumns),
        selectedSOForPs,
        tenantDepartmentId: selectedSOForPs.tenant_department_id,
      }));
    }
  }, [selectedSOForPs, tenantDepartmentId, cfV2DocPackingSlip]);

  useEffect(() => {
    const departmentLevelStock = user?.tenant_info?.inventory_config?.settings?.department_level_stock;

    // Custom Fields
    if (cfV2DocPackingSlip && !isUserReadyForCF && !match?.params?.orderId && !selectedSOForPs && !selectedSO) {
      const lineCFs = CustomFieldHelpers.getCfStructure(cfV2DocPackingSlip?.data?.document_line_custom_fields?.filter((item) => item?.is_active), false);

      setState((prevState) => ({
        ...prevState,
        cfPackingSlipDoc: CustomFieldHelpers.getCfStructure(cfV2DocPackingSlip?.data?.document_custom_fields, true),
        cfPackingSlipLine: lineCFs,
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(cfV2DocPackingSlip?.data?.document_line_custom_fields, prevState?.visibleColumns),
        data: prevState.data.map((item) => ({ ...item, lineCustomFields: lineCFs })),
        isUserReadyForCF: true,
      }));
    }
    if (!selectedSOForPs && !match?.params?.orderId && !tenantDepartmentId) {
      const tenantDepartmentId = departmentLevelStock ? user?.tenant_info?.default_department_for_sales : user?.tenant_info?.default_store_id;
      updateState('tenantDepartmentId', tenantDepartmentId);
    }

    const selectedOrder = selectedSO;
    if (selectedOrder && cfV2DocPackingSlip && !isUserReady & !selectedSOForPs) {
      const oldCustomField = selectedOrder?.custom_fields || [];
      const oldLineCustomField = selectedOrder?.sales_order_lines[0]?.so_line_custom_fields || [];
      const salesOrderLines = selectedOrder?.sales_order_lines?.map(
        (orderLine) => {
          const mergedCustomFields = CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip.data.document_line_custom_fields, orderLine?.custom_fields, true);
          const parentKey = uuidv4();
          return {
            key: parentKey,
            tenant_product_id: orderLine?.tenant_product_id,
            product_sku_name: orderLine?.product_sku_info?.product_sku_name,
            product_sku_id: orderLine?.product_sku_info?.product_sku_id,
            product_sku_info: orderLine?.product_sku_info,
            product_category_info: orderLine?.product_sku_info?.product_category_info || {},
            available_qty: orderLine?.product_sku_info?.department_quantity,
            quantity: orderLine?.order_quantity,
            free_quantity: orderLine?.order_free_quantity,
            showFreebie: Number(orderLine?.free_quantity) > 0,
            packed_quantity: Number(orderLine?.quantity || 0),
            packed_free_quantity: Number(orderLine?.free_quantity || 0),
            product_type: orderLine?.product_sku_info?.product_type,
            lineCustomFields: mergedCustomFields || [],
            product_batches: getBatches(
              Helpers.batchSelectionMethod(orderLine.default_outwards_method || Helpers.getBatchMethod(orderLine), orderLine.available_batches, (Number(orderLine.quantity) + Number(orderLine.free_quantity))),
              (Number(orderLine.quantity) + Number(orderLine.free_quantity)),
              orderLine.uom_info?.[0],
              orderLine.product_sku_info?.uom_info,
              null,
              parentKey,
            ),
            bundle_products: orderLine?.bundle_products?.map((item) => {
              const lineKey = uuidv4();
              return ({
                ...item,
                parentKey,
                key: lineKey,
                product_sku_info: item?.product_sku_info,
                product_sku_id: item?.product_sku_info?.product_sku_id,
                uom_info: item?.uom_info?.[0],
                taxId: Number(item?.tax_group_info?.tax_id),
                taxInfo: item?.tax_group_info,
                batchConsumptionMethod: item?.default_outwards_method || Helpers.getBatchMethod(item),
                quantity: Number(item?.so_quantity || item?.bundle_quantity),
                product_batches: getBatches(
                  Helpers.batchSelectionMethod(item?.default_outwards_method || Helpers.getBatchMethod(item), item?.all_product_batches, (item?.quantity + Number(item?.free_quantity))),
                  (item?.quantity + Number(item?.free_quantity)),
                  item?.uom_info?.[0],
                  item.product_sku_info?.uom_info,
                  null,
                  lineKey,
                ),
              });
            }),
            order_line_id: orderLine?.order_line_id,
            tenant_product_id: orderLine?.tenant_product_id,
            uom_info: orderLine?.uom_info?.[0],
            uom_list: orderLine?.product_sku_info?.uom_list,
            taxId: Number(orderLine?.tax_id),
            taxInfo: orderLine?.tax_group_info,
            manufacturingDateFormat: orderLine?.product_sku_info?.manufacturing_date_format,
            expiryDateFormat: orderLine?.product_sku_info?.expiry_date_format,
          };
        },
      );
      setState((prevState) => ({
        ...prevState,
        isUserReady: true,
        tenantDepartmentId: selectedOrder.tenant_department_id,
        psTypeValue: selectedOrder?.packing_slip_id ? documentUINames.salesOrderUIName : 'ADHOC', // Sales Order / Adhoc
        isFromSalesOrder: !!selectedOrder?.packing_slip_id,
        psNumber: selectedOrder?.sales_order_number,
        vehicleNumber: selectedOrder?.vehicle_number,
        selectedCustomer: Number(selectedOrder?.customer_id),
        selectedCustomerSo: selectedOrder,
        selectedCustomerInfo: selectedOrder?.customer_info,
        description: selectedOrder?.remarks,
        attachments: selectedOrder?.attachments,
        orderDate: dayjs(selectedOrder?.order_date),
        data: salesOrderLines,
        cfPackingSlipDoc: CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip?.data?.document_custom_fields, oldCustomField, true) || [],
        cfPackingSlipLine: CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip?.data?.document_line_custom_fields, oldLineCustomField, true) || [],
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(CustomFieldHelpers.postCfStructure(CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip?.data?.document_line_custom_fields, oldLineCustomField, true)), visibleColumns),
      }));
    }
  }, [cfV2DocPackingSlip, selectedSO, isUserReadyForCF, tenantDepartmentId, isUserReady]);

  const toggleBatch = (record, adjustmentRow) => {
    toggleBatchHelper({ data }, props, record, adjustmentRow, (newState) => updateState('data', newState?.data));
  };

  const toggleBatchInner = (record, adjustmentRow) => {
    toggleBatchInnerHelper({ data }, props, record, adjustmentRow, (newState) => updateState('data', newState?.data));
  };

  const handleDelete = (key) => {
    handleDeleteHelper(state, props, key, (newState) => updateState('data', newState?.data));
  };

  const showNewCustomerInSelect = (value) => {
    updateState('selectedCustomer', value?.customer_id);
  };

  const handleProductChange = (tenantSku, key, productData) => {
    handleProductChangeHelper(state, props, tenantSku, key, productData, (newState) => {
      updateState('data', newState?.data);
    });
  };

  const handleMultiProductChange = (tenantSku, key, productData, callback) => {
    handleMultiProductChangeHelper(state, props, tenantSku, productData, (newData) => {
      if (callback) {
        callback();
      }

      setState((prevState) => ({
        ...prevState,
        data: [...prevState.data, ...newData],
      }));
    });
  };

  const handleProductChangeValue = (value, key) => {
    handleProductChangeValueHelper(state, props, value, key, (newState) => updateState('data', newState?.data));
  };

  const addNewRow = (callback) => {
    addNewRowHelper(state, props, callback, (newState) => {
      updateState('data', newState?.data);
    });
  };

  function createPackingSlip(withApproval) {
    createPackingSlipHelper(state, props, withApproval, { docLevelError, lineLevelError }, (newState) => {
      updateState('formSubmitted', newState?.formSubmitted);
    });
  }

  function customInputChange(fieldValue, cfId) {
    customInputChangeHelper(state, props, fieldValue, cfId, (newState) => updateState('cfPackingSlipDoc', newState?.cfPackingSlipDoc));
  }

  const customLineInputChange = (fieldValue, key) => {
    customLineInputChangeHelper(state, props, fieldValue, key, (newState) => updateState('data', newState?.data));
  };

  const handleQuantityChange = (record, value, freeValue, showFreebie) => {
    handleQuantityChangeHelper(record, value, freeValue, showFreebie, state, props, (newState) => updateState('data', newState?.data));
  };

  const updateBatchValue = (record, value, label, batchId) => {
    updateBatchValueHelper(record, value, label, batchId, state, props, (newState) => updateState('data', newState?.data));
  };

  const handleChangeTextArea = (html) => {
    updateState('termsAndConditions', html);
  };

  const barCoding = user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active;
  const packingSlip = user?.tenant_info?.sales_config?.sub_modules?.packing_slip?.is_active;
  const { docLevelError, lineLevelError } = packingSlipErrors({
    match, selectedCustomer, selectedSO, selectedSOForPs, isFromSalesOrder, documentUINames, selectedSoValue, location, tenantDepartmentId, packingSlipDate, cfPackingSlipDoc, data, allStock,
  });
  const userMenuConfig = JSON.parse(localStorage.getItem('user_menu_config'));

  return (
    <Fragment>
      <Drawer
        open={showNewCustomerModal}
        onClose={() => updateState('showNewCustomerModal', false)}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text
              text="Add New Customer"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => updateState('showNewCustomerModal', false)}
            />
          </div>
        </div>
        <CustomerForm
          callback={(createdCustomer) => {
            getCustomers(
              '',
              (selectedSO?.tenant_id || selectedSOForPs?.tenant_id || user?.tenant_info?.tenant_id),
              1,
              1000,
              '',
              (newCustomers) => {
                showNewCustomerInSelect(
                  newCustomers?.customers.filter(
                    (customer) => customer?.customer_id === createdCustomer.customer_id,
                  )[0],
                );
                updateState('showNewCustomerModal', false);
              },
            );
          }}
        />
      </Drawer>
      {getSOByIdLoading ? (
        <FormLoadingSkull />
      ) : (
        <div className="form__wrapper form-component" style={{ paddingTop: (selectedSOForPs) ? '0px' : '90px' }}>
          {(formSubmitted && (!!docLevelError?.length || !!lineLevelError?.length)) && (
            <ErrorHandle message="Mandatory fields required" docLevelErrors={docLevelError} lineLevelErrors={lineLevelError} />
          )}
          <div className="ant-row">
            <div className="ant-col-md-24">
              <div className="form__section">
                <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
                  <H3Text text="PART A" className="form__section-title" />
                  <div className="form__section-line" />
                  <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                    <CustomDocumentInputs
                      customFields={cfPackingSlipDoc}
                      updateCustomFields={(cf) => updateState('cfPackingSlipDoc', cf)}
                    />
                  </div>
                </div>
                <div className="form__section-inputs mg-bottom-20">
                  <div className="ant-row">
                    <div className="ant-col-md-24">
                      <div
                        className="form__input-row"
                        style={{
                          alignItems: 'center',
                          marginBottom: '15px',
                        }}
                      >
                        <H3Text
                          text="Packing Slip Type"
                          className="form__input-row__label"
                        />
                        <Radio.Group
                          onChange={(event) => {
                            updateState('data', [
                              {
                                key: uuidv4(),
                                product_sku_name: '',
                                product_sku_id: '',
                                tenant_product_id: '',
                                quantity: '',
                                uom_info: '',
                                batchConsumptionMethod: '',
                                product_batches: [],
                                packed_quantity: '',
                                free_quantity: '',
                                lineCustomFields: cfPackingSlipLine,
                              },
                            ]);
                            updateState('packingSlipId', null);
                            updateState('soData', null);
                            updateState('selectedSoValue', null);
                            updateState('selectedCustomerSo', null);
                            updateState('selectedCustomer', null);
                            updateState('psTypeValue', event.target.value);
                            updateState('isFromSalesOrder', event.target.value === documentUINames.salesOrderUIName);
                            updateState('formSubmitted', false);
                            updateState('cfPackingSlipDoc', CustomFieldHelpers.getCfStructure(cfV2DocPackingSlip?.data?.document_custom_fields, true) || []);
                          }}
                          value={psTypeValue}
                          disabled={!!match?.params?.orderId}
                        >
                          <Radio value={documentUINames.salesOrderUIName}>{documentUINames.salesOrderUIName}</Radio>
                          <Radio value="ADHOC">ADHOC</Radio>
                        </Radio.Group>
                      </div>

                    </div>
                    <DocumentNumberSeqInput
                      valueFromProps={psNumber}
                      updateCase={match?.url?.includes('/update')}
                      setInitialDocSeqNumber={(value) => updateState('initialPsNumber', value)}
                      entityName="PACKING_SLIP"
                      docSeqId={docSeqId}
                      tenantId={selectedSOForPs?.tenant_id || selectedSO?.tenantId || user?.tenant_info?.tenant_id}
                      onChangeFromProps={(event, newValue, seqId) => {
                        updateState('psNumber', newValue ? (newValue || '') : (event?.target?.value || ''));
                        updateState('docSeqId', seqId);
                      }}
                      docTitle="Packing Slip#"
                      formSubmitted={formSubmitted}
                    />
                    <div className="ant-col-md-6">
                      {(match?.params?.orderId) ? (
                        <div className="form__input-row" style={{ marginBottom: '10px' }}>
                          <H3Text text="Customer" className="form__input-row__label" />
                          <div className="form__input-row__input">
                            <H3Text
                              text={selectedCustomerInfo?.customer_name}
                              style={{ padding: '7px' }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="form__input-row">
                          <H3Text required text="Customer" className="form__input-row__label" />
                          <div className="form__input-row__input">
                            <SelectCustomer
                              showAddCustomer={showAddCustomer}
                              selectedCustomer={selectedCustomer}
                              addCustomer={() => updateState('showNewCustomerModal', true)}
                              hideTitle
                              onChange={(value) => {

                                if (psTypeValue === 'ADHOC') {

                                  const docCf = CustomFieldHelpers.postCfStructure(cfPackingSlipDoc?.filter((item) => (item?.isActive && item?.visible))) || [];
                                  const customerCf = value?.custom_field_values?.filter((item) => (item?.is_active)) || [];
                                  const mergedCf = CustomFieldHelpers.mergeCustomFields(docCf, customerCf) || [];

                                  updateState('cfPackingSlipDoc', mergedCf);
                                }

                                updateState('selectedCustomer', value?.customer_id);
                                updateState('selectedCustomerInfo', value.customer_info);
                                updateState('selectedSoValue', null);
                                updateState('selectedCustomerSo', null);
                                updateState('data', [
                                  {
                                    key: uuidv4(),
                                    asset1: '',
                                    product_sku_name: '',
                                    quantity: '',
                                    unitPrice: '',
                                    lot: 0,
                                    taxId: '',
                                    discount: 0,
                                    child_taxes: [{
                                      tax_amount: 0,
                                      tax_type_name: '',
                                    }],
                                    lineCustomFields: cfPackingSlipLine,
                                  },
                                ]);
                                getSO({
                                  orgId: user?.tenant_info?.org_id,
                                  tenantId: user?.tenant_info?.tenant_id,
                                  status: 'CONFIRMED',
                                  customerId: value?.customer_id,
                                  page: 1,
                                  limit: 30,
                                  orderType: 'SALES_ORDER',
                                },
                                  (data) => {
                                    updateState('soData', data?.data?.sales_orders.filter((i) => i.fulfillment_status !== 'fulfilled'));
                                  });
                              }}
                              tenantId={selectedSO?.tenant_id || user?.tenant_info?.tenant_id}
                              disabled={createSOLoading || updateSOLoading || getDocConfigSOLoading || match?.params?.orderId}
                              containerClass="form__input-row"
                              inputClassName={`${(formSubmitted && !selectedCustomer) ? 'form__input-row__select-error' : ''}`}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    {((match?.params?.orderId && selectedSO?.packing_slip_id) || selectedSOForPs) ? (
                      <div className="ant-col-md-6">
                        <div className="form__input-row">
                          <H3Text text={documentUINames.salesOrderUIName} className="form__input-row__label" />
                          <div
                            style={{
                              color: '#2d7cf7',
                              cursor: 'pointer',
                            }}
                            className="form__input-row__input"
                          >
                            <H3Text
                              text={selectedSO?.ps_so_details?.sales_order_number || selectedSOForPs.sales_order_number}
                              style={{ padding: '7px' }}
                            />
                          </div>
                        </div>
                      </div>
                    )
                      : (
                        <React.Fragment>
                          {
                            isFromSalesOrder ? (
                              <div className="ant-col-md-6">
                                <div className="form__input-row">
                                  <H3Text required text={documentUINames.salesOrderUIName} className="form__input-row__label" />
                                  <div className={`form__input-row__input ${(formSubmitted && !selectedSoValue) ? 'form__input-row__input-error' : ''}`}>
                                    <PRZSelect
                                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                      placeholder={`Select ${documentUINames.salesOrderUIName}..`}
                                      labelInValue
                                      disabled={!selectedCustomer || createSOLoading || updateSOLoading}
                                      filterOption={false}
                                      showSearch
                                      value={selectedSoValue}
                                      onChange={(data) => {
                                        if (data) {
                                          const selectedSalesOrderCopy = soData?.filter(
                                            (item) => item.order_id === JSON.parse(data?.value)?.order_id,
                                          );
                                          getSO({
                                            orgId: user?.tenant_info?.org_id,
                                            tenantId: user?.tenant_info?.tenant_id,
                                            orderId: selectedSalesOrderCopy[0].order_id,
                                            orderType: 'SALES_ORDER',
                                          }, (selectedSalesOrder) => {
                                            const linesData = selectedSalesOrder?.data?.sales_orders?.[0]?.sales_order_lines;
                                            const accountManager = selectedSalesOrder?.data?.sales_orders?.[0]?.account_manager_info;
                                            const oldCustomField = selectedSalesOrder?.data?.sales_orders?.[0]?.custom_fields || [];

                                            const copyData = linesData?.map((order_line) => {
                                              const parentKey = uuidv4();
                                              const batches = getBatches(Helpers.batchSelectionMethod(order_line?.default_outwards_method || Helpers.getBatchMethod(order_line), order_line?.available_batches, order_line?.quantity), Math.min(order_line?.quantity + Number(order_line?.free_quantity), Helpers.getValueTotalInObject(order_line?.available_batches, 'available_qty')), order_line?.uom_info?.[0], order_line?.product_sku_info?.uom_info, null, parentKey);
                                              const copyDataItem = {
                                                key: parentKey,
                                                tenant_product_id: order_line?.tenant_product_id,
                                                packing_slip_line_id: order_line?.order_line_id,
                                                product_type: order_line?.product_type,
                                                product_sku_id: order_line?.product_sku_info?.product_sku_id,
                                                product_category_info: order_line?.product_sku_info?.product_category_info,
                                                available_qty: order_line?.available_qty,
                                                product_sku_info: order_line?.product_sku_info,
                                                product_sku_name: order_line?.product_sku_info?.product_sku_name,
                                                quantity: order_line?.quantity,
                                                free_quantity: order_line?.free_quantity,
                                                packed_quantity: Number(order_line?.quantity || 0),
                                                packed_free_quantity: Number(order_line?.free_quantity || 0),
                                                showFreebie: Number(order_line?.free_quantity) > 0,
                                                bundle_products: order_line?.bundle_products?.map((item) => {
                                                  const lineKey = uuidv4();
                                                  return {
                                                    ...item,
                                                    parentKey,
                                                    key: lineKey,
                                                    uom_info: item?.uom_info?.[0],
                                                    product_sku_name: item?.product_sku_info?.product_sku_name,
                                                    so_quantity: item?.quantity,
                                                    expiry_days: item?.product_sku_info?.expiry_days,
                                                    product_sku_info: item?.product_sku_info,
                                                    batchConsumptionMethod: item?.default_outwards_method || Helpers.getBatchMethod(item),
                                                    product_batches: getBatches(item?.available_batches, Math.min(item?.quantity, Helpers.getValueTotalInObject(item?.available_batches, 'available_qty')), item?.uom_info?.[0], item?.product_sku_info?.uom_info, null, lineKey),
                                                  };
                                                }),
                                                uom_info: order_line?.uom_info[0],
                                                batchConsumptionMethod: order_line?.default_outwards_method || Helpers.getBatchMethod(order_line),
                                                product_batches: batches,
                                                lineCustomFields: cfPackingSlipLine,
                                                manufacturingDateFormat: order_line?.product_sku_info?.manufacturing_date_format,
                                                expiryDateFormat: order_line?.product_sku_info?.expiry_date_format,
                                              };

                                              return copyDataItem;
                                            });
                                            const filteredCfData = () => oldCustomField?.filter((customField) => cfV2DocPackingSlip?.data?.document_custom_fields?.some((x) => x?.cf_id === customField?.cf_id)) || [];
                                            const oldLineCustomField = linesData?.[0]?.custom_fields || [];

                                            setState((prevState) => ({
                                              ...prevState,
                                              packingSlipId: selectedSalesOrderCopy?.[0]?.order_id,
                                              data: copyData,
                                              selectedCustomer: selectedSalesOrderCopy?.[0]?.customer_id,
                                              selectedCustomerInfo: selectedSalesOrderCopy?.[0]?.customer_info,
                                              accountManager,
                                              tenantDepartmentId: selectedSalesOrderCopy?.[0]?.tenant_department_id,
                                              selectedSoValue: data,
                                              selectedCustomerSo: selectedSalesOrderCopy?.[0],
                                              cfPackingSlipDoc: CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip.data.document_custom_fields || [], oldCustomField || []) || [],
                                              cfPackingSlipLine: CustomFieldHelpers.mergeCustomFields(cfV2DocPackingSlip.data.document_line_custom_fields, oldLineCustomField) || [],
                                            }));
                                          });
                                        }
                                      }}
                                      allowClear
                                      onClear={() => {
                                        updateState('data', [{
                                          key: uuidv4(),
                                          product_sku_name: '',
                                          product_sku_id: '',
                                          tenant_product_id: '',
                                          quantity: '',
                                          uom_info: '',
                                          batchConsumptionMethod: '',
                                          product_batches: [],
                                          packed_quantity: '',
                                          lineCustomFields: cfPackingSlipLine,
                                        }]);
                                        updateState('selectedSoValue', null);
                                        updateState('selectedCustomerSo', null);
                                      }}
                                    >
                                      {soData && soData?.filter((item) => item?.fulfillment_status !== 'fulfilled').map((item) => (
                                        <Option key={item.order_id} value={JSON.stringify(item)}>
                                          {`#${item.sales_order_number} (${toISTDate(item.created_date).format('DD/MM/YYYY')}) - ${MONEY((item.order_grand_total), item?.org_currency_info?.currency_code)}`}
                                        </Option>
                                      ))}
                                    </PRZSelect>
                                    {
                                      selectedCustomerSo && (
                                        <H3Text
                                          text={`View ${documentUINames.salesOrderUIName}`}
                                          className="create-ps__view-so-button"
                                          onClick={() => {
                                            const win = window.open(`/sales/sales-order/view/${selectedCustomerSo?.order_id}`, '_blank');
                                            win.focus();
                                          }}
                                        />
                                      )
                                    }
                                  </div>
                                </div>
                              </div>
                            ) : ''
                          }
                        </React.Fragment>
                      )}
                    <div className="ant-col-md-6">
                      <div
                        className="form__input-row"
                      >
                        <H3Text
                          required
                          text="Department"
                          className="form__input-row__label"
                        />
                        {(!match?.params?.orderId || location?.state?.cloneSo) ? (
                          <div className="form__input-row__input">
                            <SelectDepartment
                              hideTitle
                              tenantId={selectedSO?.tenant_id || user?.tenant_info?.tenant_id}
                              selectedDepartment={tenantDepartmentId}
                              onChange={(value) => {
                                updateState('tenantDepartmentId', value?.tenant_department_id);
                                updateState('departmentId', value.department_id);
                                updateState('data', [
                                  {
                                    key: uuidv4(),
                                    asset1: '',
                                    product_sku_name: '',
                                    quantity: '',
                                    unitPrice: '',
                                    lot: 0,
                                    taxId: '',
                                    discount: 0,
                                    child_taxes: [{
                                      tax_amount: 0,
                                      tax_type_name: '',
                                    }],
                                    lineCustomFields: cfPackingSlipLine,
                                  },
                                ]);
                                getProductsSuccess(null, false);
                              }}
                              emptyNotAllowed
                              loading={createSOLoading || updateSOLoading || getDocConfigSOLoading}
                              disabled={createSOLoading || updateSOLoading || getDocConfigSOLoading || !!selectedSoValue}
                              labelClassName="form__input-row__label"
                              inputClassName="orgFormInput input"
                              tenentLevelDepartment
                              showSearch
                            />
                            {formSubmitted && !tenantDepartmentId && (
                              <div className="input-error">
                                *Please select a department
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            className="form__input-row__input"
                            style={{ marginBottom: '10px' }}
                          >
                            <H3Text
                              text={selectedSO?.tenant_department_info?.alias_name || selectedSOForPs?.tenant_department_info?.alias_name}
                              style={{ padding: '7px' }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="ant-col-md-6">
                      <div className="form__input-row orgInputContainer">
                        <H3Text
                          required
                          text="Packing Date"
                          className="form__input-row__label"
                        />
                        <div className={`form__input-row__input  ${(formSubmitted && !packingSlipDate) ? 'form__input-row__input-error' : ''}`}>
                          <DatePicker
                            value={packingSlipDate}
                            onChange={(value) => {
                              updateState('packingSlipDate', value);
                            }}
                            style={{
                              border: '1px solid rgba(68, 130, 218, 0.2)',
                              borderRadius: '2px',
                              height: '28px',
                              padding: '1px 3px',
                              width: '100%',
                              background: 'white',
                            }}
                            disabled={createSOLoading || updateSOLoading || getDocConfigSOLoading}
                            format="DD/MM/YYYY"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ant-col-md-6">
                      <div className="form__input-row">
                        <H3Text
                          text="Vehicle Number"
                          className="form__input-row__label"
                        />
                        <H3FormInput
                          name="Vehicle Number"
                          type="text"
                          containerClassName="orgInputContainer form__input-row__input"
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput input"
                          placeholder=""
                          value={vehicleNumber}
                          onChange={(e) => updateState('vehicleNumber', e.target.value)}
                        />
                      </div>
                    </div>
                    {accountManager?.first_name && (
                      <div className="ant-col-md-6">
                        <div className="form__input-row">
                          <H3Text
                            text="Sales Manager"
                            className="form__input-row__label"
                          />
                          <div className="form__input-row__input">
                            <H3Text
                              text={accountManager?.first_name}
                              style={{ padding: '7px' }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <CustomFieldV3
                      customFields={cfPackingSlipDoc}
                      customInputChange={(value, cfId) => customInputChange(value, cfId)}
                      formSubmitted={formSubmitted}
                      wrapperClassName="ant-col-md-6"
                      containerClassName="form__input-row"
                      labelClassName="form__input-row__label"
                      inputClassName="form__input-row__input"
                      errorClassName="form__input-row__input-error"
                      disableCase={createSOLoading || updateSOLoading}
                      hideTitle
                      isCarryForward={true}
                    />
                  </div>
                  <div className="ant-row">
                    <div className="ant-col-md-6">
                      <div className="form__input-row">
                        <H3Text text="Internal Remarks" className="form__input-row__label" />
                        <div className="form__input-row__input">
                          <textarea
                            rows="5"
                            cols="50"
                            value={description}
                            onChange={(e) => updateState('description', e.target.value)}
                            disabled={createSOLoading}
                            style={{
                              resize: 'none',
                              backgroundColor: 'rgb(239, 239, 239)',
                              border: 'none',
                              borderRadius: '4px',
                              marginRight: '15px',
                              height: '103px',
                              padding: '4px 8px',
                              width: '100%',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ant-col-md-6">
                      <div className="form__input-row">
                        <H3Text className="form__input-row__label" text="Attachment" />
                        <Upload
                          action={Constants.UPLOAD_FILE}
                          listType="picture-card"
                          fileList={attachments}
                          disabled={createSOLoading}
                          onChange={(fileListData) => {
                            updateState('attachments',
                              fileListData?.fileList?.map((item) => ({
                                ...item,
                                url: item?.response?.response?.location || item?.url,
                              })));
                          }}
                          multiple
                        >
                          {attachments?.length >= 20 ? null : uploadButton}
                        </Upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="form__lines-wrapper">
            {tenantDepartmentId && (
              <PsLines
                title={() => (
                  <div className="form-title__wrapper">
                    <H3Text
                      text={`Packing Slip Products (${data?.filter(
                        (item) => item.product_sku_name?.length > 0,
                      )?.length
                        })`}
                      className="form__input-row__label"
                    />
                    &nbsp; &nbsp;
                    <CustomDocumentColumns
                      visibleColumns={visibleColumns}
                      setVisibleColumns={(val) => updateState('visibleColumns', val)}
                      customColumns={cfPackingSlipLine}
                      data={data}
                      updateData={(updatedData) => updateState('data', updatedData)}
                    />
                  </div>
                )}
                allStock={allStock}
                toggleAllStock={() => updateState('allStock', !allStock)}
                handleDelete={handleDelete}
                handleProductChange={handleProductChange}
                handleProductChangeValue={handleProductChangeValue}
                data={getDataSource(data)}
                addNewRow={() => addNewRow()}
                updateData={(updatedData) => updateState('data', updatedData)}
                formSubmitted={formSubmitted}
                loading={
                  getSOByIdLoading
                  || createSOLoading
                  || updateSOLoading || getDocConfigSOLoading
                  || getProductByIdLoading
                }
                tenantDepartmentId={tenantDepartmentId}
                tenantId={selectedSOForPs?.tenant_id || selectedSO?.tenant_id || user?.tenant_info?.tenant_id}
                selectedCustomer={selectedCustomer}
                visibleColumns={visibleColumns}
                cfPackingSlipLine={cfPackingSlipLine}
                customInputChange={customInputChange}
                customLineInputChange={(value, key) => customLineInputChange(value, key)}
                handleQuantityChange={handleQuantityChange}
                toggleBatch={(batch, adjustmentRow) => toggleBatch(batch, adjustmentRow)}
                toggleBatchInner={(batch, adjustmentRow) => toggleBatchInner(batch, adjustmentRow)}
                isFromSalesOrder={isFromSalesOrder}
                updateBatchValue={(record, value, label, batchId) => updateBatchValue(record, value, label, batchId)}
                isCarryForward={isCarryForward}
                handleMultiProductChange={handleMultiProductChange}

              />
            )}
          </div>
          {(!isFromSalesOrder && !selectedSO) && (
            <div className="form__data-wrapper">
              <div className="ant-row">
                <div className="ant-col-md-24">
                  <div
                    className={`new-row-button ${data?.find((item) => !(item?.product_sku_id || item?.product_sku_info?.product_sku_id)) ? 'new-row-button__disabled' : ''}`}
                    onClick={() => {
                      if (!data?.find((item) => !(item?.product_sku_id || item?.product_sku_info?.product_sku_id))) addNewRow();
                    }}
                  >
                    <span className="new-row-button__icon">
                      <PlusCircleFilled />
                    </span>
                    <div>New Item</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="ant-row">
            <div className="ant-col-md-24" style={{ marginBottom: '10px' }} />
            <div className="ant-col-md-12">
              <div className="form__data-tc">
                <label className="orgFormLabel">
                  Terms and Conditions
                </label>
                <RichTextEditor
                  onChange={(value) => handleChangeTextArea(value)}
                  value={termsAndConditions}
                  disabled={createSOLoading || updateSOLoading || getDocConfigSOLoading}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={`form__footer ${userMenuConfig === "FIXED" ? 'form__footer-fixed' : ''}`}>
        {(match?.url?.includes('/update')) ? (
          <Fragment>
            <PRZConfirmationPopover
              title="Are you sure you want to update?"
              content={(
                <Fragment>
                  <PRZText text="Reason" required />
                  <PRZInput
                    placeholder="Enter update reason"
                    value={updateDocumentReason}
                    onChange={(e) => setState((prevState) => ({
                      ...prevState,
                      updateDocumentReason: e.target.value,
                    }))}
                  />
                </Fragment>
              )}
              onConfirm={() => {
                updateState('currentAction', 'SAVE_AS_DRAFT');
                if (!createSOLoading) {
                  createPackingSlip(false);
                }
              }}
              confirmButtonText="Confirm"
              cancelButtonText="Back"
              confirmDisabled={!updateDocumentReason}
            >
              <PRZButton
                type="default"
                wrapperStyle={{ marginRight: '10px' }}
                buttonStyle={{
                  width: '130px',
                  height: '40px',
                  border: '1px solid #2d7df7',
                  color: '#2d7df7',
                }}
                isLoading={
                  currentAction === 'SAVE_AS_DRAFT'
                  && ((!withApproval && createSOLoading)
                    || updateSOLoading || getDocConfigSOLoading || getOrgStatusSalesOrderLoading)
                }
                disabled={createSOLoading || updateSOLoading || getDocConfigSOLoading || !packingSlip}
              >
                Save as Draft
              </PRZButton>
            </PRZConfirmationPopover>
            <PRZConfirmationPopover
              title="Are you sure you want to update?"
              content={(
                <Fragment>
                  <PRZText text="Reason" required />
                  <PRZInput
                    placeholder="Enter update reason"
                    value={updateDocumentReason}
                    onChange={(e) => setState((prevState) => ({
                      ...prevState,
                      updateDocumentReason: e.target.value,
                    }))}
                  />
                </Fragment>
              )}
              onConfirm={() => {
                updateState('currentAction', 'SAVE_AND_ISSUE');
                if (!createSOLoading) {
                  createPackingSlip(true);
                }
              }}
              confirmButtonText="Confirm"
              cancelButtonText="Back"
              confirmDisabled={!updateDocumentReason}
            >
              <PRZButton
                isLoading={
                  currentAction === 'SAVE_AND_ISSUE'
                  && ((withApproval && createSOLoading)
                    || updateSOLoading || getDocConfigSOLoading || getOrgStatusSalesOrderLoading)
                }
                disabled={createSOLoading || updateSOLoading || getDocConfigSOLoading || !packingSlip}
                buttonStyle={{ width: '130px', height: '40px' }}
              >
                Save and Issue
              </PRZButton>
            </PRZConfirmationPopover>
          </Fragment>
        ) : (
          <Fragment>
            <PRZButton
              type="default"
              onClick={() => {
                updateState('currentAction', 'SAVE_AS_DRAFT');
                if (!createSOLoading) {
                  createPackingSlip(false);
                }
              }}
              isLoading={
                currentAction === 'SAVE_AS_DRAFT'
                && ((!withApproval && createSOLoading)
                  || updateSOLoading || getDocConfigSOLoading || getOrgStatusSalesOrderLoading)
              }
              disabled={createSOLoading || updateSOLoading || getDocConfigSOLoading || !packingSlip}
              wrapperStyle={{ marginRight: '10px' }}
              buttonStyle={{
                width: '130px',
                height: '40px',
                border: '1px solid #2d7df7',
                color: '#2d7df7',
              }}
            >
              Save as Draft
            </PRZButton>
            <PRZButton
              onClick={() => {
                updateState('currentAction', 'SAVE_AND_ISSUE');
                if (!createSOLoading) {
                  createPackingSlip(true);
                }
              }}
              isLoading={
                currentAction === 'SAVE_AND_ISSUE'
                && ((withApproval && createSOLoading)
                  || updateSOLoading || getDocConfigSOLoading || getOrgStatusSalesOrderLoading)
              }
              disabled={createSOLoading || updateSOLoading || getDocConfigSOLoading || !packingSlip}
              buttonStyle={{ width: '130px', height: '40px' }}
            >
              Save and Issue
            </PRZButton>
          </Fragment>
        )}
        {!packingSlip && (
          <Popconfirm
            placement="topRight"
            title="This feature is not accessible within your current plan to use this feature contact us."
            onConfirm={() => window.Intercom('showNewMessage')}
            okText="Contact Us"
            cancelText="Cancel"
          >
            <img
              className="barcode-restrict"
              src={Crown}
              alt="premium"
              style={{
                marginLeft: '8px',
                marginTop: '5px',
              }}
            />
          </Popconfirm>
        )}

        <div className="form-barcode__wrapper" style={{ display: 'flex' }}>
          {!barCoding && (
            <Popconfirm
              placement="topRight"
              title="This feature is not accessible within your current plan to use this feature contact us."
              onConfirm={() => window.Intercom('showNewMessage')}
              okText="Contact Us"
              cancelText="Cancel"
            >
              <img className="barcode-restrict" src={Crown} alt="premium" />
            </Popconfirm>
          )}
          <BarcodeReader
            productTypes={['STORABLE', 'SERVICE', 'BUNDLE', 'NON_STORABLE']}
            isSalesProduct
            excludedProducts={data?.map((item) => JSON.stringify(item?.product_sku_id)) || []}
            tenantDepartmentId={tenantDepartmentId}
            excludeOutOfStock
            filterReservedQuantity
            onSearch={(tenantSku) => {
              if (data[data?.length - 1]?.product_sku_id) {
                addNewRow((key) => handleProductChange(tenantSku, key));
              } else {
                handleProductChange(tenantSku, data[data?.length - 1]?.key);
              }
            }}
            disabled={!barCoding}
          />
        </div>

      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, SOReducers, CustomerReducers, ProductReducers, CFV2Reducers, CustomStatusReducers, DocConfigReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  createSOLoading: SOReducers.createSOLoading,
  updateSOLoading: SOReducers.updateSOLoading,
  getSOByIdLoading: SOReducers.getSOByIdLoading,
  selectedSO: SOReducers.selectedSO,
  cfV2DocPackingSlip: CFV2Reducers.cfV2DocPackingSlip,
  selectedProduct: ProductReducers.selectedProduct,
  getProductByIdLoading: ProductReducers.getProductByIdLoading,
  getCustomersLoading: CustomerReducers.getCustomersLoading,
  getCustomerByIdLoading: CustomerReducers.getCustomerByIdLoading,
  orgStatusSalesOrder: CustomStatusReducers.orgStatusSalesOrder,
  getOrgStatusSalesOrderLoading: CustomStatusReducers.getOrgStatusSalesOrderLoading,
  docConfigSO: DocConfigReducers.docConfigSO,
  getDocConfigSOLoading: DocConfigReducers.getDocConfigSOLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomers: (keyword, tenantId, page, limit, customerId, callback) => dispatch(CustomerActions.getCustomers(keyword, tenantId, page, limit, customerId, callback)),
  createSO: (payload, callback) => dispatch(SOActions.createSO(payload, callback)),
  updateSO: (payload, callback) => dispatch(SOActions.updateSO(payload, callback)),
  getSO: (payload, callback) => dispatch(SOActions.getSO(payload, callback)),
  getSOById: (payload, callback) => dispatch(SOActions.getSOById(payload, callback)),
  getProductById: (tenantId, productSkuId, tenantDepartmentId, callback, filterReservedBatches, productSkuIds) => dispatch(ProductActions.getProductById(tenantId, productSkuId, tenantDepartmentId, callback, filterReservedBatches, productSkuIds)),
  getSOByIdSuccess: (salesOrders) => dispatch(SOActions.getSOByIdSuccess(salesOrders)),
  updateSOStatus: (payload, callback) => dispatch(SOActions.updateSOStatus(payload, callback)),
  getDocCFV2Success: (customFields) => dispatch(CFV2Actions.getDocCFV2Success(customFields)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getProductsSuccess: (products, forOffers) => dispatch(ProductActions.getProductsSuccess(products, forOffers)),
  getOrgStatus: (payload, callback) => dispatch(CustomStatusActions.getOrgStatus(payload, callback)),
  getDocConfig: (tenantId, entityName, callback) => dispatch(DocConfigActions.getDocConfig(tenantId, entityName, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(PackingSlipForm));
